import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";

import { type TeamMemberTaskWithTrainee } from "@fitness-app/data-models/entities/TeamMemberTask";

import { TeamMemberTaskItem } from "./TeamMemberTaskItem";

interface DraggableTaskItemProps {
  task: TeamMemberTaskWithTrainee;
  disabled?: boolean;
  showDate?: boolean;
}

export const DraggableTaskItem: React.FC<DraggableTaskItemProps> = ({ task, disabled = false, showDate = false }) => {
  const { attributes, listeners, setNodeRef, transform, isDragging } = useDraggable({
    id: task.id,
    data: { task },
    disabled,
  });

  const style: React.CSSProperties = {
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.5 : 1,
    cursor: disabled ? "default" : "grab",
    touchAction: "none",
  };

  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      <TeamMemberTaskItem task={task} showDate={showDate} />
    </div>
  );
};
